import styled from "styled-components";

interface ContentStyleProps {
  $shade?: boolean;
}

export const PointStandardContent = styled.div`
  gap: 32px;
  display: flex;
  flex-direction: column;
`;

export const ContentMainBox = styled.div`
  gap: 30px;
  display: flex;
  padding: 30px;
  background: ${(props) => props.theme.colors.white100};
  box-shadow: ${(props) => props.theme.shadows.box};
  align-items: center;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
`;

export const ContentMainTit = styled.div`
  gap: 12px;
  display: flex;
  font-size: 2rem;
  font-weight: 400;
  line-height: 150%;
  align-items: center;
  flex-direction: column;

  b {
    color: ${(props) => props.theme.colors.primary100};
    font-weight: 800;
  }

  span {
    width: fit-content;
    color: ${(props) => props.theme.colors.primary100};
    display: inline-block;
    padding: 4px 8px;
    font-size: 1.2rem;
    background: ${(props) => props.theme.colors.primary12};
    font-weight: 600;
    line-height: 150%;
    border-radius: 6px;
  }
`;

export const ContentHeader = styled.div`
  gap: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const ContentInfoBox = styled.div`
  gap: 10px;
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.primary12};
  display: flex;
  padding: 14px 24px;
  background: ${(props) => props.theme.colors.primaryBg};
  border-radius: 8px;
  flex-direction: column;

  div {
    gap: 6px;
    color: ${(props) => props.theme.colors.text3};
    display: flex;
    font-size: 1.3rem;
    font-weight: 400;
    align-items: center;

    span {
      width: 18px;
      color: ${(props) => props.theme.colors.white100};
      height: 18px;
      display: flex;
      font-size: 1rem;
      background: ${(props) => props.theme.colors.primary100};
      font-weight: 800;
      align-items: center;
      border-radius: 50%;
      justify-content: center;
    }
  }
`;

export const ContentMainTxt = styled.p`
  color: ${(props) => props.theme.colors.text2};
  font-size: 1.2rem;

  b {
    color: ${(props) => props.theme.colors.primary100};
    font-weight: 800;
    text-decoration: underline;
    text-underline-offset: 4px;
  }
`;

export const ContentBox = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
`;

export const ContentTit = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
`;

export const Content = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
`;

export const ContentItem = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;

  & > span {
    color: ${(props) => props.theme.colors.text2};
    font-size: 1.2rem;
  }
`;

export const ItemList = styled.ul<ContentStyleProps>`
  gap: 20px;
  display: flex;
  padding: 20px;
  background: ${(props) =>
    props.$shade === true
      ? props.theme.colors.white100
      : props.theme.colors.mainBg};
  box-shadow: ${(props) =>
    props.$shade === true ? props.theme.shadows.box : "none"};
  border-radius: 10px;
  flex-direction: column;
`;

export const Item = styled.li`
  width: 100%;
  display: flex;
  font-size: 1.3rem;
  line-height: 150%;
  align-items: center;
  justify-content: space-between;

  & > span {
    gap: 6px;
    color: ${(props) => props.theme.colors.primary100};
    display: flex;
    padding: 4px 6px;
    background: ${(props) => props.theme.colors.primary12};
    font-weight: 600;
    line-height: 150%;
    white-space: nowrap;
    border-radius: 6px;
  }

  & > div {
    display: flex;
    flex-direction: column;

    span {
      color: ${(props) => props.theme.colors.primary100};
      font-size: 1.1rem;
      font-weight: 700;
    }
  }

  & > p {
    b {
      color: ${(props) => props.theme.colors.primary100};
    }
  }
`;
